import React from 'react';
import Pannello from './Pannello';
import TabellaDoppia from './TabellaDoppia';
import { totaliNuovi, perNome } from './analisi';

/**
 * Chi non si era mai visto.
 *
 * Due colonne, due domande diverse: "mai visti" sono i giocatori che non compaiono in nessuna
 * edizione precedente di nessun circuito, "nuovi qui" quelli che non compaiono in nessuna
 * edizione precedente di questo circuito. I primi sono un sottoinsieme dei secondi, e la
 * differenza fra le due colonne e' gente che lo scoutball lo conosce, ma non da queste parti.
 *
 * Gli accompagnatori non ci sono: sono un numero sull'iscrizione, non hanno anagrafica, e
 * contarli per nuovi sarebbe inventare.
 */

const ETICHETTE_STORICA = {
  nuova: 'nuova',
  ritorno: 'di ritorno',
  nonAgganciata: 'non agganciata'
};

const INTESTAZIONI = [
  { testo: 'Squadra' },
  { testo: 'Giocatori' },
  { testo: 'Nuovi qui', titolo: 'Non hanno mai giocato una edizione precedente di questo torneo' },
  { testo: 'Mai visti', titolo: 'Non hanno mai giocato nessuna edizione di nessun torneo' },
  { testo: 'Storica' }
];

const PannelloPersoneNuove = ({ squadre, aperto = false }) => {
  const totali = totaliNuovi(squadre);
  const ordinate = perNome(squadre);

  return (
    <Pannello
      aperto={aperto}
      icona="fa-user-plus"
      titolo="Persone nuove"
      sommario={`${totali.nuoviCircuito} nuovi per il circuito, ${totali.nuoviAssoluti} al primo torneo`}
    >
      {squadre.length === 0 ? (
        <p className="pannello-vuoto">Nessuna squadra iscritta.</p>
      ) : (
        <>
          <div className="numeroni">
            <div className="numerone">
              <span className="numerone-valore">{totali.nuoviCircuito}</span>
              <span className="numerone-etichetta">alla prima edizione di questo torneo</span>
            </div>
            <div className="numerone">
              <span className="numerone-valore">{totali.nuoviAssoluti}</span>
              <span className="numerone-etichetta">al primo torneo in assoluto</span>
            </div>
            <div className="numerone">
              <span className="numerone-valore">{totali.giocatori - totali.nuoviCircuito}</span>
              <span className="numerone-etichetta">gia' visti qui</span>
            </div>
            <div className="numerone">
              <span className="numerone-valore">{totali.giocatori}</span>
              <span className="numerone-etichetta">giocatori iscritti</span>
            </div>
          </div>

          <TabellaDoppia
            intestazioni={INTESTAZIONI}
            righe={ordinate}
            riga={(s) => (
              <tr key={s.id}>
                <td><span className="nome-squadra" title={s.nome}>{s.nome}</span></td>
                <td>{s.giocatori}</td>
                <td><strong>{s.nuoviCircuito}</strong></td>
                <td>{s.nuoviAssoluti}</td>
                <td>
                  <span className={`pastiglia pastiglia-${s.storica}`}>
                    {ETICHETTE_STORICA[s.storica] ?? s.storica}
                  </span>
                </td>
              </tr>
            )}
          />

          <div className="riga-totali">
            <span><strong>{squadre.length}</strong> squadre</span>
            <span><strong>{totali.giocatori}</strong> giocatori</span>
            <span><strong>{totali.nuoviCircuito}</strong> nuovi per il circuito</span>
            <span><strong>{totali.nuoviAssoluti}</strong> al primo torneo</span>
            <span><strong>{totali.giocatori - totali.nuoviCircuito}</strong> gia' visti qui</span>
          </div>
        </>
      )}
    </Pannello>
  );
};

export default PannelloPersoneNuove;
